<template>
  <div>
    <wc-page-title title='Profile'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <profile-basics
            :profile='profile'
            @update='update'
          ></profile-basics>
        </v-col>
        <v-col cols='12' md='4'>
          <profile-details
            :profile='profile'
            @update='update'
          ></profile-details>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/staffing/views/profileDetail/Basics'
import Details from '@/modules/staffing/views/profileDetail/Details'

export default {
  name: 'profile',
  computed: {
    profile () {
      return this.$store.state.auth.profile
    }
  },
  methods: {
    update (profileCopy) {
      this.$emit('update', profileCopy)
    }
  },
  components: {
    'profile-basics': Basics,
    'profile-details': Details
  }
}
</script>
